import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { BaseService } from '../../util/base-service.service';
import { HttpConst } from '../../core/resources/http/http.const';
import { HttpClient  } from '@angular/common/http';
import { ServiceResult, ServiceResultModel } from '../../shared/models/service-result.model'; // ADD EXP(CFJC) 20210519 REQ19649
import { TerminosResponseModel } from '../models/generacionclave/paso1/response/terminos-response.model'; // ADD EXP(CFJC) 20210519 REQ19649
import { Observable } from 'rxjs'; // ADD EXP(CFJC) 20210519 REQ19649
import { NuevaClaveRequest } from '../models/generacionclave/paso3/request/nueva-clave-request.model';
import { NuevaClaveResponse } from '../models/generacionclave/paso3/response/nueva-clave-response.model';
import { CambioClaveRequest } from '../models/cambioclave/paso3/request/cambio-clave-request.model';
import { CambioClaveResponse } from '../models/cambioclave/paso3/response/cambio-clave-response.model';
import { CambioClaveExpiracionRequest } from '../models/cambioporexpiracion/paso1/request/cambio-clave-expiracion-request.model';
import { CambioClaveExpiracionResponse } from '../models/cambioporexpiracion/paso1/response/cambio-clave-expiracion-response.model';
import { CambioDatoRequest } from '../../actualizar/request/cambio-correo-request.model'; //ADD INE(EGB) 20220709 - REQ22111
import { CambioCorreoResponse } from '../../actualizar/response/cambio-correo-response-model'; //ADD INE(EGB) 20220709 - REQ22111
import { TokenBanTotal } from '../models/main/tokenBanTotal.model';
import { TokenBanTotalResponse } from '../models/main/response/tokenBanTotalResponse.model';
import { BodyTeclado } from '../models/generacionclave/paso3/request/BodyTeclado.model'; //ADD INE(JJGJ) 20230727 REQ25238
import { CambioClaveTemporalRequest } from '../models/cambioporclavetemporal/request/cambio-clave-tempora-request.model';
import { CambioClaveTemporalResponse } from '../models/cambioporclavetemporal/response/cambio-clave-temporal-response.model';

@Injectable()
export class SeguridadService extends BaseService {

  $api = `${HttpConst.apiUrl}`;
  $controllerName = 'Seguridad';
  $controllerNamePrestamo = 'PrestamoPersonal'; //ADD INE(EGB) 20220705 - REQ22111

  constructor(private http: HttpClient) { super(http); }

  autenticarUsuario(usuario: any) {
    const resultado = <Promise<any>>(
    this.httpPostNonSecure(`${this.$api}/token/Generar`, usuario)
    );
    //const resultado = <Promise<any>>this.httpPost(`${this.$api}/${this.$controllerName}/AutenticarUsuario`, usuario);
    return resultado;
  }

  obtenerTerminosAfiliacion(): Observable<ServiceResultModel<TerminosResponseModel, any>> { // ADD EXP(CFJC) 20210519 REQ19649
    // const resultado = <Promise<any>>this.httpGetNonSecure(`${this.$api}/${this.$controllerName}/CreacionUsuario/Terminos`); // MOD EXP(CFJC) 20210519 REQ19649
    const resultado = this.httpGet(`${this.$api}/${this.$controllerName}/CreacionUsuario/Terminos`, null, true) as Observable<ServiceResultModel<TerminosResponseModel, any>>; // ADD EXP(CFJC) 20210519 REQ19649
    return resultado;
  }

  generarCaptcha() {
    const resultado = <Promise<any>>this.httpGetNonSecure(`${this.$api}/${this.$controllerName}/Captcha`);
    return resultado;
  }

  verificarCaptcha(codigo: any) {
    const resultado = <Promise<any>>
    this.httpPostNonSecure(`${this.$api}/${this.$controllerName}/VerificarCaptcha`,
    codigo
    );
    return resultado;
  }

  obtenerDatosClientePorContrato(nroContrato: any) {
    const resultado = <Promise<any>>this.httpPostNonSecure(`${this.$api}/${this.$controllerName}/CreacionUsuario/ValidaContrato`, nroContrato);
    return resultado;
  }

  verificarUsuarioAfiliado(nroContrato: any) {
    const resultado = <Promise<any>>this.httpPostNonSecure(`${this.$api}/${this.$controllerName}/CreacionUsuario/VerificaAfiliacion`, nroContrato);
    return resultado;
  }

  generarCodigoSeguridad(codigoSeguridad: any) {
    const resultado = <Promise<any>>this.httpPostNonSecure(`${this.$api}/${this.$controllerName}/CreacionUsuario/GeneraCodigoSeguridad`, codigoSeguridad);
    return resultado;
  }

  /*INICIO: INE(EGB) 20220629 - REQ22111*/
  generarCodigoSeguridadActualizar(codigoSeguridad: any) {
    const resultado = <Promise<any>>this.httpPostNonSecure(`${this.$api}/${this.$controllerName}/ActualizarDato/GeneraCodigoSeguridad`, codigoSeguridad);
    return resultado;
  }
  verificarCodigoSeguridadActualizarDato(input: any) {
    const resultado = <Promise<any>>this.httpPostNonSecure(`${this.$api}/${this.$controllerName}/ActualizarDato/VerificaCodigoSeguridad`, input);
    return resultado;
  }
  ActualizarDato(data: CambioDatoRequest): Observable<ServiceResult<CambioCorreoResponse>> {
    const resultado = this.httpPost<CambioDatoRequest, ServiceResult<CambioCorreoResponse>>(`${this.$api}/${this.$controllerName}/ActualizarDato/ActualizaDatoPersonal`, data, true);
    return resultado;
  }
  /*FIN: INE(EGB) 20220629 - REQ22111*/

  verificarCodigoSeguridad(input: any) {
    const resultado = <Promise<any>>this.httpPostNonSecure(`${this.$api}/${this.$controllerName}/CreacionUsuario/VerificaCodigoSeguridad`, input);
    return resultado;
  }

  verificarClave(input: any) {
    const resultado = <Promise<any>>this.httpPostNonSecure(`${this.$api}/${this.$controllerName}/CreacionUsuario/VerificaClave`, input);
    return resultado;
  }

  obtenerDatosCliente(input: any) {
    const resultado = <Promise<any>>this.httpPostNonSecure(`${this.$api}/${this.$controllerName}/CambioClave/ValidaDocumento`, input);
    return resultado;
  }

  generarCodigoSeguridadCambioClave(codigoSeguridad: any) {
    const resultado = <Promise<any>>this.httpPostNonSecure(`${this.$api}/${this.$controllerName}/CambioClave/GeneraCodigoSeguridad`, codigoSeguridad);
    return resultado;
  }
  ////<!--INICIO: CSTI(EACN) 20240206 - REQ25710-->
  generarCodigoSeguridadPrueba(codigoSeguridad: any) {
    const resultado = <Promise<any>>this.httpPostNonSecure(`${this.$api}/${this.$controllerName}/PruebaCodigo/GeneraCodigoSeguridadPrueba`, codigoSeguridad);
    return resultado;
  }
  ////<!--FIN: CSTI(EACN) 20240206 - REQ25710-->
  verificarCodigoSeguridadCambioClave(input: any) {
    const resultado = <Promise<any>>this.httpPostNonSecure(`${this.$api}/${this.$controllerName}/CambioClave/VerificaCodigoSeguridad`, input);
    return resultado;
  }

  verificarClaveCambioClave(input: any) {
    const resultado = <Promise<any>>this.httpPostNonSecure(`${this.$api}/${this.$controllerName}/CambioClave/VerificaClave`, input);
    return resultado;
  }

  verificarClaveCambioExpirada(input: any) {
    const resultado = <Promise<any>>this.httpPost(`${this.$api}/${this.$controllerName}/CambioClaveExpiracion/VerificaClave`, input);
    return resultado;
  }

  cerrarSesionCliente(input: any) {
    const resultado = <Promise<any>>this.httpPost(`${this.$api}/${this.$controllerName}/CerrarSesionCliente`, input);
    return resultado;
  }


  /*INICIO: INE(EGB) 20220629 - REQ22111*/

  obtenerPrestamoPersonal(input: any) {
    const resultado = <Promise<any>>this.httpPost(`${this.$api}/${this.$controllerNamePrestamo}/ValidaPrestamoPersonal`, input);
    return resultado;
  }

  /*FIN: INE(EGB) 20220629 - REQ22111*/

  obtenerTerminosDesafiliacion() {
    const resultado = <Promise<any>>this.httpGet(`${this.$api}/${this.$controllerName}/Desafiliacion/Terminos`);
    return resultado;
  }

  obtenerDatosClientePorUsuario(input: any) {
    const resultado = <Promise<any>>this.httpPost(`${this.$api}/${this.$controllerName}/Desafiliacion/DatosClientePorUsuario`, input);
    return resultado;
  }

  generarCodigoSeguridadDesafiliacion(codigoSeguridad: any) {
    const resultado = <Promise<any>>this.httpPost(`${this.$api}/${this.$controllerName}/Desafiliacion/GeneraCodigoSeguridad`, codigoSeguridad);
    return resultado;
  }

  verificarCodigoSeguridadDesafiliacion(input: any) {
    const resultado = <Promise<any>>this.httpPost(`${this.$api}/${this.$controllerName}/Desafiliacion/VerificaCodigoSeguridad`, input);
    return resultado;
  }

  confirmarDesafiliacion(input: any) {
    const resultado = <Promise<any>>this.httpPost(`${this.$api}/${this.$controllerName}/Desafiliacion/ConfirmarDesafiliacion`, input);
    return resultado;
  }

  //INI EXP(CFJC) 20210519 REQ19649
 // async generarTecladoTokenizado(dispositivo: number): Promise<any> { // MOD - INE(JJGJ) 20230727 REQ25238 - SE COMENTo
    async generarTecladoTokenizado(data: BodyTeclado): Promise<any> { // ADD - INE(JJGJ) 20230727 REQ25238
   // const resultado = this.httpGet(`${this.$api}/${this.$controllerName}/teclado/${dispositivo}`); // MOD - INE(JJGJ) 20230727 REQ25238 - SE COMENTo
    const resultado = <Promise<any>>this.httpPost(`${this.$api}/${this.$controllerName}/teclado`,data); // ADD - INE(JJGJ) 20230727 REQ25238
    return resultado;
  }

  generarClave(data: NuevaClaveRequest): Observable<ServiceResult<NuevaClaveResponse>> {
    const resultado = this.httpPost<NuevaClaveRequest, ServiceResult<NuevaClaveResponse>>(`${this.$api}/${this.$controllerName}/usuario/clave`, data, true);
    return resultado;
  }

  cambiarClave(data: CambioClaveRequest): Observable<ServiceResult<CambioClaveResponse>> {
    const resultado = this.httpPost<CambioClaveRequest, ServiceResult<CambioClaveResponse>>(`${this.$api}/${this.$controllerName}/usuario/cambio-clave`, data, true);
    return resultado;
  }

  cambiarClavePorExpiracion(data: CambioClaveExpiracionRequest): Observable<ServiceResult<CambioClaveExpiracionResponse>> {
    const resultado = this.httpPost<CambioClaveExpiracionRequest, ServiceResult<CambioClaveExpiracionResponse>>(`${this.$api}/${this.$controllerName}/usuario/clave-expiracion`, data, true);
    return resultado;
  }
  //FIN EXP(CFJC) 20210519 REQ19649
  //INI INE(JJGJ) 20221018 - REQ22978
  generarCodigoSeguridadCredenciales(codigoSeguridad: any) {
    const resultado = <Promise<any>>this.httpPostNonSecure(`${this.$api}/${this.$controllerName}/ValidacionCredenciales/GenerarCodigoSeguridadAdmin`, codigoSeguridad);
    return resultado;
  }
  verificarCodigoSeguridadAdmin(input: any) {
    const resultado = <Promise<any>>this.httpPostNonSecure(`${this.$api}/${this.$controllerName}/ValidacionCredenciales/verificarCodigoSeguridadAdmin`, input);
    return resultado;
  }
  //FIN INE(JJGJ) 20221018 - REQ22978


    // INICIO EXP(SMM) 20220111 - REQ21426 Servicio para la obtención del Token de Ban Total
    generarTokenBanTotal(
      data: TokenBanTotal
    ): Observable<ServiceResultModel<TokenBanTotalResponse, any>> {
      const resultado = this.httpPost<
        TokenBanTotal,
        ServiceResultModel<TokenBanTotalResponse, any>
      >(`${this.$api}/token/generar/bantotal`, data, true);

      return resultado;
    }
    // FIN EXP(SMM) 20220111 - REQ21426
  cambiarClavePorClaveTemp(data: CambioClaveTemporalRequest): Observable<ServiceResult<CambioClaveTemporalResponse>>{
    const resultado = this.httpPost<CambioClaveTemporalRequest,ServiceResult<CambioClaveTemporalResponse>>(`${this.$api}/${this.$controllerName}/usuario/clave-temporal`, data, true);
    return resultado;
  }
  obtenerDatosClienteClaveTemp(data: any){
    const resultado = <Promise<any>>this.httpPostNonSecure(`${this.$api}/${this.$controllerName}/ClaveTemporal/ValidaDocumento`, data);
    return resultado;
  }
}
